module.exports = __webpack_public_path__ + "assets/home-bg1-de8e2f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./Content/images/home-bg1.jpg
 ** module id = 918
 ** module chunks = 2
 **/